 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTTITLEPAGE from '@/components/Text/titlepage'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTDED from '@/components/Text/ded'
 import TEXTTOC from '@/components/Text/toc'
 import TEXTINTRO from '@/components/Text/intro'
 import TEXT1 from '@/components/Text/1'
 import TEXT2 from '@/components/Text/2'
 import TEXT3 from '@/components/Text/3'
 import TEXT4 from '@/components/Text/4'
 import TEXT5 from '@/components/Text/5'
 import TEXT6 from '@/components/Text/6'
 import TEXT7 from '@/components/Text/7'
 import TEXT8 from '@/components/Text/8'
 import TEXT9 from '@/components/Text/9'
 import TEXT10 from '@/components/Text/10'
 import TEXT11 from '@/components/Text/11'
 import TEXT12 from '@/components/Text/12'
 import TEXTEPI from '@/components/Text/epi'
 import LOVE_2 from '@/components/love_2'
 import TEXTACK from '@/components/Text/ack'
 import TEXTNOTES from '@/components/Text/notes'
 import TEXTREF from '@/components/Text/ref'
 import TEXTAPPA from '@/components/Text/appa'
 import TEXTAPPB from '@/components/Text/appb'
 import TEXTAPPC from '@/components/Text/appc'
 import TEXTPHOTOSECTION from '@/components/Text/photosection'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/toc",
 			"name" : "Text/toc",
 			"component" : TEXTTOC
 		},
 		{
 			"path" : "/Text/intro",
 			"name" : "Text/intro",
 			"component" : TEXTINTRO
 		},
 		{
 			"path" : "/Text/1",
 			"name" : "Text/1",
 			"component" : TEXT1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js